import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { StorageService } from 'src/app/services/storage.service';

@Component({
  selector: 'app-form-success',
  templateUrl: './form-success.component.html',
  styleUrls: ['./form-success.component.scss']
})
export class FormSuccessComponent implements OnInit {

  constructor(private router: Router, private storage: StorageService) { }

  homeButton() {
    this.router.navigate(['']);
  }

  ngOnInit(): void {
    this.storage.clear();
  }

}
